const DefaultFilter = {
    page:1,
    pageSize:10,
    term:''

}

export default DefaultFilter;
